import { useSelector } from 'react-redux'

import { COMMUNICATION_MODE_INTERCOM } from '@constants'

/**
 * The active company's communication channel. Independent from the service type — never derive one
 * from the other.
 *
 * Returns `null` while the company details are in flight (guessing would flash the wrong channel)
 * and when logged out; a logged-in user with no company keeps the Intercom default.
 */
export function useCommunicationMode(): Nullable<CommunicationMode> {
  const company = useSelector((state: Store) => state.auth.company.data)
  const requestedCompanyId = useSelector((state: Store) => state.auth.company.lastRequestedCompanyId)
  const isLoggedIn = useSelector((state: Store) => Boolean(state.auth.user))

  if (company) {
    return company.communication_mode
  }
  if (requestedCompanyId != null) {
    return null
  }
  return isLoggedIn ? COMMUNICATION_MODE_INTERCOM : null
}
